import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";

// Get free trial users list
export const getFreeTrialUsers = async (params) => {
  try {
    const response = await authenticatedAxios.get(
      `${baseurl}subscriptions/free-trial-users/`,
      { params }
    );

    const data = response.data?.data ?? response.data;

    if (Array.isArray(data)) {
      return data;
    }

    throw new Error("Invalid data format");
  } catch (error) {
    throw new Error(error.message || "Failed to fetch free trial users");
  }
};

// Get all plan extension requests
export const getPlanExtensions = async (params = {}) => {
  try {
    const response = await authenticatedAxios.get(
      `${baseurl}subscriptions/plan-extensions-req/`,
      { params }
    );
    const data = response.data?.data ?? response.data;
    if (Array.isArray(data)) return data;
    throw new Error("Invalid data format");
  } catch (error) {
    throw new Error(error.message || "Failed to fetch plan extensions");
  }
};

// Approve a plan extension (admin provides start_date + end_date)
export const approvePlanExtension = async (pk) => {
  try {
    const response = await authenticatedAxios.post(
      `${baseurl}subscriptions/plan-extensions-req/${pk}/status/`,
      { action: "approve" }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message || "Failed to approve plan extension");
  }
};

// Reject a plan extension
export const rejectPlanExtension = async (pk) => {
  try {
    const response = await authenticatedAxios.post(
      `${baseurl}subscriptions/plan-extensions-req/${pk}/status/`,
      { action: "reject" }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message || "Failed to reject plan extension");
  }
};

// Get all user limit extension requests
export const getUserLimitExtensions = async (params = {}) => {
  try {
    const response = await authenticatedAxios.get(
      `${baseurl}subscriptions/user-limit-extensions-req/`,
      { params }
    );

    const data = response.data?.data ?? response.data;
    if (Array.isArray(data)) return data;

    throw new Error("Invalid data format");
  } catch (error) {
    throw new Error(error.message || "Failed to fetch user limit extensions");
  }
};


// Approve
export const approveUserLimitExtension = async (pk) => {
  try {
    const response = await authenticatedAxios.post(
      `${baseurl}subscriptions/user-limit-extensions-req/${pk}/status/`,
      { action: "approve" }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message || "Failed to approve request");
  }
};


// Reject
export const rejectUserLimitExtension = async (pk) => {
  try {
    const response = await authenticatedAxios.post(
      `${baseurl}subscriptions/user-limit-extensions-req/${pk}/status/`,
      { action: "reject" }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message || "Failed to reject request");
  }
};